import { render } from "./ActivateBannerDialog.vue?vue&type=template&id=0fec0494"
import script from "./ActivateBannerDialog.vue?vue&type=script&lang=js"
export * from "./ActivateBannerDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__